import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
/* global window */
/* eslint-disable no-underscore-dangle */
import { LOG } from './types';
var colors = {
  DEBUG: 'blue',
  INFO: 'green',
  WARN: 'orange',
  ERROR: 'red',
  FATAL: 'red'
};
var _log = function _log(level, fields, msg) {
  // $FlowIgnore[unclear-type]
  var _level = fields.level || level.toUpperCase();
  try {
    window.console.groupCollapsed('%s %c %s%s: ', new Date().toTimeString(), "color: ".concat(colors[_level]), _level,
    // Need to check that that it's not an empty string too
    fields.namespace && typeof fields.namespace === 'string' ? " [".concat(fields.namespace, "]") : '', msg);
    window.console.log(fields);
    window.console.groupEnd();
  } catch (e) {
    window.console.log('%s  %s%s: %s', new Date().toTimeString(), _level,
    // Need to check that that it's not an empty string too
    fields.namespace && typeof fields.namespace === 'string' ? " ".concat(fields.namespace) : '', msg, fields);
  }
};
var _defaultLogger = {
  debug: function debug() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _log.apply(void 0, ['debug'].concat(args));
  },
  info: function info() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return _log.apply(void 0, ['info'].concat(args));
  },
  warn: function warn() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return _log.apply(void 0, ['warn'].concat(args));
  },
  error: function error() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return _log.apply(void 0, ['error'].concat(args));
  },
  fatal: function fatal() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }
    return _log.apply(void 0, ['error'].concat(args));
  }
};

/**
 * Redux middleware to intercept log actions
 *
 * ## Usage
 *
 * ``` javascript
 * import { applyMiddleware, createStore } from 'redux';
 * import { createAppLogger } from 'gandi-application-logger';
 *
 * let appLogger = createAppLogger({logger: myLogger});
 * ....
 * applyMiddleware([appLogger])(createStore);
 * ```
 */
export function createAppLogger(options) {
  return function () {
    return function (next) {
      return (
        // $FlowFixMe[unclear-type] It's any possible action
        function (action) {
          if (action.type !== LOG) {
            return next(action);
          }
          var level = action.level;
          var cleanOptions = _objectSpread({
            logger: _defaultLogger
          }, options);
          var logger = cleanOptions.logger;

          // concat the bunyan logger namespace if present
          if (logger.fields && logger.fields.namespace) {
            // explicitly mutate the action payload
            // eslint-disable-next-line no-param-reassign
            action.fields.namespace = [logger.fields.namespace, action.fields.namespace].join('/');
          }
          try {
            // $FlowFixMe[incompatible-use]
            logger[level](action.fields, action.message);
          } catch (e) {
            // eslint-disable-next-line testing-library/no-debugging-utils
            logger.debug("Invalid log level \"".concat(level, "\""));
            // explicitly mutate the action payload
            // eslint-disable-next-line no-param-reassign
            action.fields = _objectSpread(_objectSpread({}, action.fields), {}, {
              level: level
            });
            logger.info(action.fields, action.message);
          }

          // we do not call `next` here to stop log action propagation
          return null;
        }
      );
    };
  };
}